import React from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu } from 'antd';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';

const DropDownWrapper = styled.div`
  .dropdown-button {
    box-sizing: border-box !important;
    height: 44px !important;
    padding: 10px 14px !important;
    min-width: 100% !important;

    display: flex !important;
    flex-direction: row !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 8px !important;

    background: #ffffff !important;
    border: 1px solid #d5d7da !important;
    box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05) !important;
    border-radius: 8px !important;

    &:hover,
    &:focus,
    &:active {
      background: #ffffff !important;
      border: 1px solid #d5d7da !important;
      color: inherit !important;
    }

    > span {
      display: flex;
      align-items: center;
    }
  }

  .dropdown-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    width: 264px;
    width: 100% !important;
    height: 24px;
    flex-grow: 1;
    overflow: hidden;
  }

  .selected-key {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #181d27;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .arrow-symbol {
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #717680;
    font-size: 12px;
  }

  .ant-btn > span {
    width: 100%;
  }
`;

const StyledMenu = styled(Menu)`
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0px 12px 16px -4px rgba(10, 13, 18, 0.08),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03);

  .ant-dropdown-menu-item,
  .ant-menu-item {
    min-height: 40px;
    border-radius: 6px;
    display: flex;
    align-items: center;

    font-family: 'Inter', sans-serif;
    font-size: 16px;
    line-height: 24px;
    font-weight: 500;
    color: #181d27;
  }

  .ant-dropdown-menu-item:hover,
  .ant-menu-item:hover {
    background: #f5fbee !important;
  }

  .ant-dropdown-menu-item-selected,
  .ant-menu-item-selected {
    background: #f5fbee !important;
    color: #3f621a !important;
  }
`;

const DropDown = ({ setSelectedKey, options }) => {
  const selectedKey = useSelector((state) => state.payment.donationType);

  const handleMenuClick = (e) => {
    setSelectedKey(Number(e.key));
  };

  const getLabel = (items, key) => {
    if (items[key]?.label) return items[key].label;
    const found = items.find((item) => item.key === key);
    return found ? found.label : '';
  };

  const menu = (
    <StyledMenu onClick={handleMenuClick} selectedKeys={[String(selectedKey)]}>
      {options.map((item) => (
        <Menu.Item key={String(item.key)}>{item.label}</Menu.Item>
      ))}
    </StyledMenu>
  );

  return (
    <DropDownWrapper>
      <Dropdown overlay={menu} trigger={['click']} placement="bottomLeft">
        <Button className="dropdown-button">
          <div className="dropdown-content">
            <span className="selected-key">
              {getLabel(options, selectedKey)}
            </span>
          </div>

          <div className="arrow-symbol">
            <DownOutlined />
          </div>
        </Button>
      </Dropdown>
    </DropDownWrapper>
  );
};

export default DropDown;
